import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Bg from '../../images/shapes/memecoin_bg_shape_2.svg'
import Bg2 from '../../images/shapes/shape_net_2.svg'

// Import images
import iconMentoring from "../../images/services/client_focus.gif";
import iconMobileBanking from "../../images/services/hessle_free.gif";
import iconRecommendation from "../../images/services/design_stand_out.gif";
import partnerLogo1 from "../../images/partners/partner_logo_1.png";
import partnerLogo2 from "../../images/partners/partner_logo_2.png";
import partnerLogo3 from "../../images/partners/partner_logo_3.png";
import partnerLogo4 from "../../images/partners/partner_logo_4.png";
import partnerLogo5 from "../../images/partners/partner_logo_5.png";
import partnerLogo6 from "../../images/partners/partner_logo_6.png";
import partnerLogo7 from "../../images/partners/partner_logo_7.png";
import Modal from '../Modal/Modal';

const ChooseSection = () => {
    const [buttonText, setButtonText] = useState("Copy");

    const services = [
        {
            icon: iconMentoring,
            alt: "Mentoring",
            title: "Client-Focused Approach",
            description: "We collaborate closely with clients to deliver perfection.",
        },
        {
            icon: iconMobileBanking,
            alt: "Mobile Banking",
            title: "Hassle-Free Process",
            description: "First interaction to the last,  every conversation is smooth.",
        },
        {
            icon: iconRecommendation,
            alt: "Recommendation",
            title: "Designs That Stand Out",
            description: "Perfect visuals that fit in every role!",
        },
    ];

    const partners = [partnerLogo1, partnerLogo2, partnerLogo3, partnerLogo4, partnerLogo5, partnerLogo6, partnerLogo7];

    // Handle Copy Button Click
    const handleCopyClick = () => {
        const codeText = document.querySelector(".code mark").textContent;
        const textarea = document.createElement("textarea");
        document.body.appendChild(textarea);
        textarea.value = codeText;
        textarea.select();

        try {
            document.execCommand("copy");
            setButtonText("Copied!");

            // Reset text after 2 seconds
            setTimeout(() => {
                setButtonText("Copy");
            }, 2000);
        } catch (err) {
            console.error("Copy failed", err);
        }

        document.body.removeChild(textarea);
    };

    var settings = {
        dots: false,
        infinite: true,
        speed: 5000,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        arrows: false,

        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 340,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <section
            id="id_memecoin_service_section"
            className={`memecoin_service_section section_space`}
            style={{ backgroundImage: `url(${Bg})` }}
        >
            <div className="container">
                <div className="memecoin_heading_block text-center">
                    <h2 className="heading_text text-uppercase mb-0">
                        Why Choose <mark>Us</mark>
                    </h2>
                </div>

                <div className="row m-0 text-center">
                    {services.map((service, index) => (
                        <div className="col-lg-4 p-0" key={index} data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                            <div className="memecoin_iconbox_block">
                                <div className="iconbox_icon">
                                    <img src={service.icon} alt={service.alt} />
                                </div>
                                <div className="iconbox_info">
                                    <h3 className="iconbox_title text-uppercase">{service.title}</h3>
                                    <p className="mb-0">{service.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div
                    className="memecoin_partners_logo text-center"
                    style={{ backgroundImage: `url(${Bg2})` }}
                    data-aos="fade-up" data-aos-duration="800" data-aos-delay="400">
                    <div className="memecoin_heading_block">
                        <h3 className="heading_text text-uppercase mb-0 text-light">Types of logos we offer</h3>
                    </div>

                    <Slider {...settings}>
                        {partners.map((logo, index) => (
                            <div className="ico_partner_logo" key={index}>
                                <a className="logo_wrap" href="#!">
                                    <img src={logo} alt="Partner Logo" />
                                </a>
                            </div>
                        ))}
                    </Slider>

                    <ul className="btns_group unordered_list justify-content-center p-0 mt-5" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
                        <li>

                        </li>
                        <li>
                            <button className="memecoin_btn bg-light text-black" onClick={openModal}>
                                <span className="btn_label">Get a Free Quote</span>
                                <span className="btn_bg" style={{ maskImage: `url(${Bg2})` }}></span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            {isModalOpen && <Modal onClose={closeModal} />}
        </section>
    );
};

export default ChooseSection;
